<template>
	<main>
		<ResponsiveLayout>
			<TopBottomLayout>
				<h6>ETF</h6>
				<HomeItemLayout class="home-item_layout">
					<BannerEtf />
					<section v-if="getBannerMulti?.etf_top && getBannerMulti?.etf_top?.length > 0">
						<SubSwiperSlide :data="getBannerMulti?.etf_top ?? []" />
					</section>
				</HomeItemLayout>
				<EtfCategoryGridList class="hot-rank_grid-list" @upload:item="onClickCard" />
				<section v-if="getBannerMulti?.etf_bottom && getBannerMulti?.etf_bottom?.length > 0">
					<SubSwiperSlide :data="getBannerMulti?.etf_bottom ?? []" />
				</section>
			</TopBottomLayout>
		</ResponsiveLayout>
	</main>
</template>

<script setup lang="ts">
// core
import { computed, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router';

import { useGetCheckAuthApi } from '@/api/auth';
// api
import { useGetBannerMultiApi } from '@/api/banner';
import BannerEtf from '@/components/banner/BannerEtf.vue';
import EtfCategoryGridList from '@/components/etf/EtfCategoryGridList.vue';
import HomeItemLayout from '@/components/home/HomeItemLayout.vue';
import ResponsiveLayout from '@/components/layout/main/ResponsiveLayout.vue';
import TopBottomLayout from '@/components/layout/main/TopBottomLayout.vue';
import SubSwiperSlide from '@/components/swiper/SubSwiperSlide.vue';
import { useModalStore } from '@/stores/modal';

// -----variable-----
const router = useRouter();
const modalStore = useModalStore();

// -----api-----
const { refetch: refetchCheckAuth } = useGetCheckAuthApi(
	computed(() => ({
		num: 'ALL',
		student: false,
		enable: false,
	}))
);
const { data: getBannerMulti } = useGetBannerMultiApi({
	type: 'etf_top,etf_bottom',
});

// -----function-----
const onClickCard = async (item: string) => {
	if (item === '섹터') router.push(`/sector/usa/${item}`);
	else router.push(`/etf/list/${item}`);
};

onBeforeMount(async () => {
	const res = await refetchCheckAuth();
	if (!res.data?.success) {
		// router.replace(`/subscribe/usa/not`);
		modalStore.openModal('GuideModal');
	}
});
</script>

<style lang="scss" scoped>
.home-item_layout {
	gap: 2rem;
	.banner-sub {
		img {
			@media screen and (max-width: 1280px) {
				height: 8.2rem;
			}
		}
	}
}
.hot-rank_grid-list {
	grid-template-columns: repeat(3, 1fr);
	gap: 1rem;
	@media screen and (max-width: 1280px) {
		grid-template-columns: repeat(2, 1fr);
	}
}
</style>
